import React from 'react';
import { Input, theme } from 'antd';
import { ICustomTextareaProps } from 'store/ducks/Global/types';
import * as Styled from './CustomTextarea.styled';

const { useToken } = theme;
const { TextArea } = Input;

export const CustomTextarea: React.FC<ICustomTextareaProps> = ({
  placeholder,
  onChange,
  ...rest
}) => {
  const { token } = useToken();

  return (
    <Styled.TextareaWrapper token={token}>
      <TextArea
        rows={1}
        placeholder={placeholder}
        onChange={onChange}
        {...rest}
      />
    </Styled.TextareaWrapper>
  );
};
